/** Инициалы для аватара: первые буквы имени и фамилии, иначе первые буквы адреса */
export function initials(fullName: string | null, email: string): string {
	const words = (fullName ?? '').split(/\s+/).filter(Boolean);
	const source = words.length >= 2 ? `${words[0][0]}${words[1][0]}` : email.slice(0, 2);
	return source.toUpperCase();
}
